import { useEffect } from "react";
import { useAuthStore } from "../shared/store/authStore";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

export const Root = () => {
  const loadFromStorage = useAuthStore((s) => s.loadFromStorage);

  useEffect(() => {
    loadFromStorage();
    console.log("Взяли данные о пользователе из хранилища");
  }, [loadFromStorage]);

  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
};

export default Root;
